// extracted by mini-css-extract-plugin
export var originalPrice = "_vs-0";